import React, { useState } from 'react';
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './info-banner.css';

interface InfoBannerProps {
  message: string;
}

const InfoBanner: React.FunctionComponent<InfoBannerProps> = ({ message }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="info-banner">
      <InfoCircleOutlined className="info-banner-icon" />
      <span className="info-banner-text">{message}</span>
      <button
        className="info-banner-close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
      >
        <CloseOutlined />
      </button>
    </div>
  );
};

export default InfoBanner;
